import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type FactoryResetPayload = {};

export type FactoryResetEvent = {};

const factoryResetSchema = z.object({});

export const LID_FACTORY_RESET = {
  value: 0x52,
  name: "Factory Reset Event",
  format: ".............",
  fields: [],
  postprocess: () => ({}),
  schema: factoryResetSchema,
} as const satisfies TandemEventDefinition<FactoryResetPayload, FactoryResetEvent>;
